import React from 'react'

import clsx from 'clsx'

import { BaseLayoutProps, Layout } from './Layout'
import * as styles from './Layout.module.scss'

import {
  useHotelNewsApi,
  useNotificationsApi,
  useRouteParams,
} from '../../../hooks'
import { News, Notification, PageTitle } from '../../contents'

export type ReservationLayoutProps = BaseLayoutProps & {
  pageTitle: string
  reservationName?: string
}

export const ReservationLayout: React.FC<ReservationLayoutProps> = ({
  pageTitle,
  reservationName,
  children,
}) => {
  const { data: notifications } = useNotificationsApi()
  const { property } = useRouteParams()
  const { data: news } = useHotelNewsApi(property)

  return (
    <Layout>
      <div>
        <PageTitle title={pageTitle} reservationName={reservationName} />
      </div>
      {((notifications && notifications?.length > 0) ||
        (news && news?.contentJa)) && (
        <div
          className={clsx(styles.notificationWrapper, styles.reservationLayout)}
        >
          {notifications && notifications.length > 0 && (
            <Notification notifications={notifications} />
          )}
          {news && news.contentJa && <News news={news} />}
        </div>
      )}
      <div className={clsx(styles.reservation)}>{children}</div>
    </Layout>
  )
}
